import browse from './asda-browse.svg'
import change from './asda-change.svg'
import check from './asda-check.svg'
import close from './asda-close.svg'
import filter from './asda-filter.svg'
import menu from './asda-menu.svg'
import plus from './asda-plus.svg'
import minus from './asda-minus.svg'
import pause from './asda-pause.svg'
import reload from './asda-reload.svg'
import search from './asda-search.svg'
import sort from './asda-sort.svg'
import swap from './asda-swap.svg'
import zoom from './asda-zoom.svg'

import caretDown from './asda-caret-down.svg'
import chevronDown from './asda-chevron-down.svg'
import moreActions from './asda-more-actions.svg'
import sortAscending from './asda-sort-ascending.svg'
import sortDescending from './asda-sort-descending.svg'

export default {
  browse,
  change,
  check,
  close,
  filter,
  menu,
  plus,
  minus,
  pause,
  reload,
  search,
  sort,
  swap,
  zoom,
  'caret-down': caretDown,
  'chevron-down': chevronDown,
  'more-actions': moreActions,
  'sort-ascending': sortAscending,
  'sort-descending': sortDescending,
}



// WEBPACK FOOTER //
// ./common/components/icon/basic/index.js